module.exports = __webpack_public_path__ + "static/media/drop_down.0c219e70.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Support/imgs/drop_down.svg
// module id = 826
// module chunks = 0